import {
  AuthorizationPanel,
} from '../../features/authorization/AuthorizationPanel'

import type {
  GenesisExtensionManifest,
} from '../../platform/extensions/types'

export const manifest:
GenesisExtensionManifest = {
  id: 'authorization',
  name: 'Autorización',

  description:
    'HUMAN_ONCE y autorización exacta del plan.',

  version: '1.0.0',
  apiVersion: '1',

  kind: 'MODULE',
  placement: 'RIGHT',

  priority: 20,

  enabledByDefault: false,
  removable: true,

  requiredCapabilities: [
    'authorization.read',
  ],

  component: AuthorizationPanel,

}
